import Field from './Field'

export default function FieldSelect (label, key, items, rules, options, on) {
  Field.call(this, label, key, rules, options, on)
  this.type = 'select'
  this.items = items
}



// WEBPACK FOOTER //
// ./packages/helper/fields/FieldSelect.js